/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgRotateBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.6 12.5997H17.4M9 20.9997C8.68174 20.9997 8.37652 20.8732 8.15147 20.6482C7.92643 20.4232 7.8 20.1179 7.8 19.7997M19.8 20.9997C20.1183 20.9997 20.4235 20.8732 20.6485 20.6482C20.8736 20.4232 21 20.1179 21 19.7997M7.8 16.1997V17.3997M21 16.1997V17.3997M11.4 21H13.2M15.6 21H17.4M19.8 12.5997C20.1183 12.5997 20.4235 12.7261 20.6485 12.9511C20.8736 13.1762 21 13.4814 21 13.7997M11.4 12.5997H13.2M14.7512 3.59967L13.376 4.97567C13.3203 5.03133 13.2761 5.09742 13.2459 5.17017C13.2158 5.24293 13.2002 5.32091 13.2002 5.39967M13.2002 5.39967C13.2002 5.47843 13.2158 5.55642 13.2459 5.62918C13.2761 5.70193 13.3203 5.76802 13.376 5.82367L14.7512 7.19967M13.2002 5.39967H16.2C16.8365 5.39967 17.447 5.65253 17.8971 6.10262C18.3471 6.5527 18.6 7.16315 18.6 7.79967V10.7997M16.8 9.2487L18.176 10.6239C18.2317 10.6796 18.2977 10.7238 18.3705 10.754C18.4433 10.7842 18.5212 10.7997 18.6 10.7997M18.6 10.7997C18.6788 10.7997 18.7567 10.7842 18.8295 10.754C18.9023 10.7238 18.9683 10.6796 19.024 10.6239L20.4 9.2487M3.8 3H10.6C11.0418 3 11.4 3.35817 11.4 3.8V15.4C11.4 15.8418 11.0418 16.2 10.6 16.2H3.8C3.35817 16.2 3 15.8418 3 15.4V3.8C3 3.35817 3.35817 3 3.8 3Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgRotate = wrapIcon(SvgRotateBase);
export default SvgRotate;
